// extracted by css-extract-rspack-plugin
export default {"link":"_c2f0186f","img":"_7ff15d0c","text":"_3fa29cd2"};